module.exports = __webpack_public_path__ + "static/OXID eShop-3cc0126dcddcbb2ce431388b3a30c6b6.svg";